import { mapMutations, mapState } from 'vuex';
import VueScrollTo from 'vue-scrollto';

import {
    CLEAR_COPIED_RENDERING,
    CLEAR_SELECTED_ELEMENTS,
    HIDE_SNACKBAR,
    SET_COPIED_ELEMENTS,
    SET_CUT_CALLBACK,
    SHOW_SNACKBAR,
    TOGGLE_ADDING_ORGANISMS,
    SET_CHANGED_DATA,
} from '@/store/types/mutation-types';

export default {
    computed: {
        ...mapState({
            addingOrganisms: state => state.page.addingOrganisms,
            moving: state => state.page.moving,
            onCutCallback: state => state.page.onCutCallback,
            selectedElements: state => state.page.selectedElements,
        }),
    },

    methods: {
        ...mapMutations({
            clearCopiedRendering: CLEAR_COPIED_RENDERING,
            clearSelectedElements: CLEAR_SELECTED_ELEMENTS,
            hideSnackbar: HIDE_SNACKBAR,
            setCopiedElements: SET_COPIED_ELEMENTS,
            setCutCallback: SET_CUT_CALLBACK,
            showSnackbar: SHOW_SNACKBAR,
            toggleAddingOrganisms: TOGGLE_ADDING_ORGANISMS,
            setChangedData: SET_CHANGED_DATA,
        }),

        onCut({ element, onCutCallback }) {
            this.showSnackbar({
                title: 'Select a drop zone to move the component into.',
                text: 'Press the esc key to cancel.',
            });

            // the cut callback allows the originating drop zone to remove the element after a successful cut operation
            this.setCutCallback(() => onCutCallback(element));

            this.onCutCopy('cut', [element]);
        },

        onCopy() {
            this.showSnackbar({
                title: 'Select a drop zone to copy the component(s) into.',
                text: 'Press the esc key to cancel.',
            });

            this.onCutCopy('copy', this.selectedElements.map(elem => elem.updatedElement));
        },

        async onCutCopy(mode, elements) {
            this.clearSelectedElements();

            await this.$nextTick();

            if (!this.addingOrganisms) {
                this.toggleAddingOrganisms(true);
            }

            this.setCopiedElements({
                mode,
                pageId: this.pageId,
                elements,
            });
        },

        async afterPaste(element) {
            await this.$nextTick();

            if (element) {
                const DomElement = document.getElementById(element.id);

                VueScrollTo.scrollTo(DomElement, 500, {
                    easing: 'ease-in',
                    offset: -60,
                    force: true,
                });
            }

            this.clearCopiedRendering();
            this.hideSnackbar();
            this.setChangedData(true);
        },
    },
};
